var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.899 50.211L97.811 56.3l-3.638 12.52H42.494c-19.04 0-31.356-11.002-37.595-18.609zm84.567-3.189v2.564l10.069.775-1.123 3.867-95.248-6.242C1.041 45.115 0 43.124 0 43.124l22.93 1.397L34.072 31.18l38.455 2.902-3.487 4.482 1.007 9.529 7.399.569v-2.429l-5.176-.34.168-3.126L100 44.577l-.167 3.125-10.367-.68zM47.471 36.457l-10.721-.571-6.685 9.13 15.092 1.161 2.314-9.72zm16.826 11.192l-.365-10.316-12.623-.673-1.907 9.844 14.895 1.145zm22.337-.813l-6.356-.417v2.461l6.356.489v-2.533z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/BOAT.bccb9b0dc109da815e3ea49d35d9bb24.svg";
export { ForwardRef as ReactComponent };